<template>
  <div>
    <el-card>
      <alter-form labelWidth="180px" ref="alterForm" @handleChange="handleChange" @formSubmit="formSubmit" :modifyData="modifyData" :formData="formData" :collapseLength="collapseLength"></alter-form>
    </el-card>
  </div>
</template>

<script>
import Logic from './index.js'
export default Logic
</script>

<style lang="scss" scope>
@import './index.scss';
</style>
